import {useTitle} from 'hooks';
import {Divider, Transitioner} from 'components';

import SettingsSignOut from './components/Settings.SignOut';
import FormSettings from './components/Form.Settings';

interface IPageSettingsProps {}

const PageSettings = ({}: IPageSettingsProps) => {
  useTitle('Settings');
  return (
    <Transitioner>
      <div className="flex items-center justify-between">
        <div className="sm:flex-auto">
          <h1 className="font-medium text-lg dark:text-white">Settings</h1>
          <p className="mt-2 text-sm text-gray-700 dark:text-darkText hidden sm:block whitespace-pre-line">Update your profile info.</p>
        </div>
        <SettingsSignOut />
      </div>
      <Divider />
      <Transitioner delay={0.1}>
        <FormSettings />
      </Transitioner>
    </Transitioner>
  );
};

export default PageSettings;
